import { gql } from '@apollo/client';

export type FetchScheduledTransfersPermissions = {
  canReadClientLowRiskPii: boolean;
};

export const FETCH_SCHEDULED_TRANSFERS_QUERY = ({
  canReadClientLowRiskPii,
}: FetchScheduledTransfersPermissions) => `
  query fetchScheduledTransfers($input: FetchScheduledTransfersInput!) {
    fetchScheduledTransfers(input: $input) {
      scheduledTransfers {
        id
        amountCents
        state
        type
        subAccount {
          id
          account {
            id
            type
            user {
              id
              ${canReadClientLowRiskPii ? 'firstName middleName lastName' : ''}
            }
          }
          goal {
            name
          }
        }
        toSubAccount {
          id
          goal {
            name
          }
          account {
            type
          }
        }
        bankAccount {
          name
          institutionNumber
          bankAccountNumber
        }
        scheduledDate
        frequency
        lastSkippedAt
        lastSkipReason
      }
      totalCount
    }
  }
`;

export const FETCH_SCHEDULED_TRANSFERS = (
  permissions: FetchScheduledTransfersPermissions,
) => gql`${FETCH_SCHEDULED_TRANSFERS_QUERY(permissions)}`;

export const CANCEL_SCHEDULED_TRANSFER = gql`
  mutation cancelScheduledTransfer($scheduledTransferId: ObjectID!) {
    cancelScheduledTransfer(scheduledTransferId: $scheduledTransferId) {
      scheduledTransfer {
        id
      }
    }
  }
`;
